import type { PlatformId } from '@/shared/components/PlatformIcon';
import { formatNumber } from '@/shared/lib/intl';
import {
  PLATFORM_RULES as SHARED_RULES,
  type PlatformIssue,
  type PlatformRule as SharedPlatformRule,
} from '@unipostudio/shared-validators';

/**
 * What each platform (and each post type within it) accepts. The rules live
 * in `@unipostudio/shared-validators` so the composer, the API and the
 * worker's readiness check can never disagree; this module re-exports them
 * with the web's icon ids and adds the words.
 */
export {
  PUBLISHABLE_RULES,
  availableTypes,
  countHashtags,
  effectiveChars,
  graphemes,
  hasLink,
  isThreadOnX,
  ruleFor,
  stillTypeFor,
  typeRule,
  typeSatisfied,
  unfilledPlaceholders,
  validateComposition,
  type MediaNeed,
  type PlatformIssue,
  type PostTypeRule,
} from '@unipostudio/shared-validators';

export interface PlatformRule extends SharedPlatformRule {
  platformId: PlatformId;
}

export const PLATFORM_RULES: PlatformRule[] = SHARED_RULES;

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** An issue's message in the reader's language. */
export function issueMessage(issue: Pick<PlatformIssue, 'messageKey' | 'params'>, t: Translate): string {
  const values: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(issue.params ?? {})) {
    if (k === 'typeKey') values['type'] = t(String(v));
    else values[k] = typeof v === 'number' ? formatNumber(v) : v;
  }
  return t(issue.messageKey, values);
}

/** "Platform: message", for lists that mix platforms. */
export function issueText(issue: Pick<PlatformIssue, 'label' | 'messageKey' | 'params'>, t: Translate): string {
  return `${issue.label}: ${issueMessage(issue, t)}`;
}
